import { Crown } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const notConnected = (what) =>
  toast.info(`${what} will connect to your eRes loyalty service`, { description: "Demo preview: not connected yet." });

export const MemberPanel = () => (
  <Popover>
    <PopoverTrigger asChild>
      <button className="flex items-center gap-2 rounded-full border border-gold/40 px-4 py-2 text-sm text-ink transition-colors hover:bg-gold/10" data-testid="member-login-trigger">
        <Crown className="h-4 w-4 text-gold" strokeWidth={1.5} /> <span className="hidden sm:inline">Game of Life</span>
      </button>
    </PopoverTrigger>
    <PopoverContent align="end" className="w-80 rounded-2xl p-6" data-testid="member-login-panel">
      <p className="eyebrow">Rewards</p>
      <h3 className="mt-1 font-serif text-2xl text-ink">Game of Life</h3>
      <form className="mt-4 space-y-3" onSubmit={(e) => { e.preventDefault(); notConnected("Member login"); }}>
        <input className="field-input" placeholder="Membership number or email" required data-testid="member-login-username" />
        <input className="field-input" type="password" placeholder="Password" required data-testid="member-login-password" />
        <button className="btn-primary w-full" data-testid="member-login-submit">Log in</button>
      </form>
      <p className="mt-4 text-sm text-ink/60">
        Not a member?{" "}
        <button className="font-medium text-brand underline-offset-4 hover:underline" onClick={() => notConnected("Join Now")} data-testid="member-join-now">
          Join Now
        </button>
      </p>
    </PopoverContent>
  </Popover>
);
